import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { setUser, clearUser, setUserRole, setAuthReady, setWhitelistedAdmin } from "../../../redux/actions/authActions";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getUserRole } from "../../utils/getUserRole";
import { checkAdminWhitelist } from "../../services/adminWhitelistService";
import { ROLES } from "../../utils/roles";
import { RootState } from "../../../redux/store/store";

const AuthBootstrapper = () => {
	const dispatch = useDispatch();
    const { authBlocked } = useSelector((state: RootState) => state.auth);

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (authBlocked) {
                return;
            }

			if (user) {

				try {
					const docRef = doc(db, "usuarios", user.uid);
					const docSnap = await getDoc(docRef);

                    let email = user.email || "Email";

					if (docSnap.exists()) {
						const data = docSnap.data();
                        dispatch(setUser(data.nombre || "Usuario", data.email || email));
                        email = data.email || email;
					} else {
						dispatch(setUser("Usuario", "Email"));
					}

					const rol = await getUserRole();
					dispatch(setUserRole(rol || "usuario"));

                    let isWhitelisted = false;
                    if (rol === ROLES.A12_B) {
                        isWhitelisted = await checkAdminWhitelist(email);
                    }

                    dispatch(setWhitelistedAdmin(isWhitelisted));

					// ⚡ Solo ahora que tenemos usuario y rol, decimos que está listo:
					dispatch(setAuthReady(true));
				} catch (error) {
					console.error("Error al restaurar usuario:", error);
					dispatch(clearUser());
					dispatch(setAuthReady(true)); // Incluso en error, debes marcar ready
				}
			} else {
				dispatch(clearUser());
				dispatch(setAuthReady(true));
			}
		});

		return () => unsubscribe();
	}, [authBlocked, dispatch]);

	return null;
};

export default AuthBootstrapper;
